export default __webpack_public_path__ + "static/media/integrately.f4b1e038.svg";